import { useEffect, useState } from 'react';
import { ContactPage, ManageAccounts, Cancel } from '@mui/icons-material';
import HttpsIcon from '@mui/icons-material/Https';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';

// material-ui
import {
    Box,
    Button,
    Grid,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Modal,
    TextField,
    FormControl,
    Select,
    MenuItem,
    Autocomplete,
    CircularProgress,
    Tooltip,
    Checkbox
} from '@mui/material';

import { useTheme } from '@mui/material/styles';
import { deepPurple, grey } from '@mui/material/colors';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { gridSpacing } from 'app/constant';

import { useSelector } from 'react-redux';
import { selectCurrentUser, selectCurrentToken } from 'features/auth/authSlice';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import { axiosInstance } from 'utils/axios';
import { toast } from 'react-toastify';
import { useCallback } from 'react';
import useFetchData from 'hooks/useFetchData';
import * as XLSX from 'xlsx';
import ImagesDialog from './components/ImagesDialog';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 1000,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const columns = [
    { id: 'id', label: 'Count', minWidth: 30 },
    { id: 'customerType', label: 'Customer Type', minWidth: 170 },
    { id: 'numberCode', label: 'Customer ID', minWidth: 30 },
    { id: 'clientName', label: 'Client Name', minWidth: 170 },
    { id: 'loginUserName', label: 'Login User Name', minWidth: 170 },
    { id: 'amount', label: 'Amount', minWidth: 170 },
    { id: 'topUpTypeName', label: 'Top Up Type', minWidth: 130 },
    { id: 'topUpAmount', label: 'Top Up Amount', minWidth: 120 },
    { id: 'statusName', label: 'Status', minWidth: 170 },
    { id: 'recommendBy', label: 'Recommend By', minWidth: 170 },
    { id: 'isLock', label: 'Is Lock', minWidth: 170 },
    { id: 'lockIncentivePercentage', label: 'Lock Percentage', minWidth: 170 },
    { id: 'cappingProfitAmount', id2: 'cappingAmount', label: 'Capping', minWidth: 170 },
    // { id: "statusName", label: "Status", minWidth: 170 },
    { id: 'packageName', label: 'Package Name', minWidth: 170 },
    { id: 'packagePercentageString', label: 'Package Percentage', minWidth: 170 },
    { id: 'packageStartDate', label: 'Package Start Date', type: 'date', minWidth: 190 },
    { id: 'packageEndDate', label: 'Package End Date', type: 'date', minWidth: 190 },
    { id: 'refundDate', label: 'Refund Date', minWidth: 170 },
    { id: 'roiDate', label: 'ROI Date', type: 'date', minWidth: 190 },
    { id: 'thirdPartyName', label: 'Third Party Name', minWidth: 170 },
    { id: 'grossProfit', label: 'GrossProfit', minWidth: 170 },
    // {
    //     id: 'thirdPartyChargesTypeName',
    //     label: 'Third Party Charges Type',
    //     minWidth: 170
    // },
    { id: 'estimatedProfit', label: 'Estimated Client Return', minWidth: 170 },
    { id: 'estimatedDailyProfit', label: 'Estimated Daily Profit', minWidth: 170 },
    { id: 'createdBy', label: 'Created By', minWidth: 170 },
    { id: 'createdDate', label: 'Created Date', minWidth: 190, type: 'date' },
    { id: 'updatedBy', label: 'Updated By', minWidth: 170 },
    { id: 'updatedDate', label: 'Updated Date', minWidth: 190, type: 'date' },
    { id: 'approvedDate', label: 'Approved Date', minWidth: 170, type: 'date' },
    { id: 'transactionNumber', label: 'Transaction Number', minWidth: 170 },
    { id: 'bankVendorName', label: 'Bank Name', minWidth: 170 },
    { id: 'bankAccountNumber', label: 'Bank Account Number', minWidth: 170 },
    { id: 'bankAccountHolderName', label: 'Bank Account Holder Name', minWidth: 170 },
    { id: 'phoneNumber', label: 'Phone Number', minWidth: 170 },
    { id: 'promotionCode', label: 'Promotion Code', minWidth: 170 }
    // { id: "clientreturn", label: "Estimated Client Return", minWidth: 170 },
];

const transactionLimitColumns = [
    { id: 'id', label: 'ID', minWidth: 30 },
    {
        id: 'thirdPartyName',
        label: 'Third Party Name',
        minWidth: 170
    },
    {
        id: 'depositLimit',
        label: 'Deposit Limit',
        minWidth: 120
    },
    {
        id: 'withdrawalLimit',
        label: 'Withdrawal Limit',
        minWidth: 120
    }
];

const walletsColumns = [
    { id: 'walletTypeID', label: 'Wallet Type ID', minWidth: 50 },
    { id: 'customerID', label: 'Customer ID', minWidth: 50 },
    {
        id: 'walletTypeName',
        label: 'Wallet Type',
        minWidth: 170
    },
    {
        id: 'balance',
        label: 'Balance',
        minWidth: 120
    }
];
const lastPayoutsColumns = [
    { id: 'dateLabel', label: 'Date Label', minWidth: 170, type: 'date' },
    {
        id: 'amount',
        label: 'Amount',
        minWidth: 170
    },
    {
        id: 'statusName',
        label: 'Status',
        minWidth: 120
    },
    {
        id: 'packageName',
        label: 'Package Name',
        minWidth: 130
    }
];

const LastPayoutRecords = ({ lastPayoutRecords }) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    // console.log(lastSalesRecords[0][amount])

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    return (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer sx={{ maxHeight: 440 }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {lastPayoutsColumns.map((column) => (
                                <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {lastPayoutRecords.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                            return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                    {lastPayoutsColumns.map((column) => {
                                        // console.log(row)
                                        let value = row[column.id];
                                        if (column.type && column.type === 'date') {
                                            if (value) {
                                                const timeString12hr = new Date(
                                                    '1970-01-01T' + value.split('T')[1] + 'Z'
                                                ).toLocaleTimeString('en-US', {
                                                    timeZone: 'UTC',
                                                    hour12: true,
                                                    hour: 'numeric',
                                                    minute: 'numeric',
                                                    second: 'numeric'
                                                });
                                                value = `${value.split('T')[0]} ${timeString12hr}`;
                                            }
                                        }
                                        return (
                                            <TableCell key={column.id} align={column.align}>
                                                {value}
                                            </TableCell>
                                        );
                                    })}
                                    {/* <TableCell><button><ManageAccounts /></button></TableCell> */}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={lastPayoutRecords.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
};

const Wallets = ({ wallets }) => {
    // console.log('Wallets Compo', wallets);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    return (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer sx={{ maxHeight: 440 }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {walletsColumns.map((column) => (
                                <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                    {column.label}
                                </TableCell>
                            ))}
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {wallets?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                            return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                    {walletsColumns.map((column) => {
                                        let value = row[column.id];

                                        if (column.type && column.type === 'date') {
                                            if (value) {
                                                const timeString12hr = new Date(
                                                    '1970-01-01T' + value.split('T')[1] + 'Z'
                                                ).toLocaleTimeString('en-US', {
                                                    timeZone: 'UTC',
                                                    hour12: true,
                                                    hour: 'numeric',
                                                    minute: 'numeric',
                                                    second: 'numeric'
                                                });
                                                value = `${value.split('T')[0]} ${timeString12hr}`;
                                            }
                                        }

                                        return (
                                            <TableCell key={column.id} align={column.align}>
                                                {value}
                                            </TableCell>
                                        );
                                    })}
                                    <TableCell>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px'
                                            }}
                                        >
                                            {/* <ViewDetailsModal id={row.id} /> */}
                                            {/* <UpdateCustomerModal customer={row} /> */}
                                            {/* <WalletBalanceModal customer={row} /> */}
                                        </Box>
                                    </TableCell>
                                    {/* <TableCell><button><ManageAccounts /></button></TableCell> */}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={wallets?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
};

const ViewDetailsModal = ({ id }) => {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const token = useSelector(selectCurrentToken);
    const [saleDetails, setSaleDetails] = useState({});
    const fetchSalesDetails = useCallback(async () => {
        try {
            const res = await axiosInstance.get(`/Sales/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setSaleDetails(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    }, [id, token]);

    useEffect(() => {
        if (open) {
            fetchSalesDetails();
        }
    }, [open, fetchSalesDetails]);

    return (
        <div>
            <Button
                onClick={handleOpen}
                sx={{
                    border: 'none',
                    backgroundColor: 'transparent',
                    width: 'fit-content',
                    height: 'fit-content',
                    color: deepPurple[500]
                }}
            >
                <ContactPage />
            </Button>
            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Typography id="modal-modal-title" variant="h3" component="h2">
                            Sales Records Details
                        </Typography>
                        <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                    </Box>

                    <Box
                        id="modal-modal-description"
                        sx={{
                            height: '500px',
                            width: 'fit-content',
                            overflowY: 'auto'
                        }}
                    >
                        <Grid item container xs={12} sx={{ mt: 2 }}>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Client Name :{' '}
                                    <span style={{ fontWeight: 600 }}>
                                        {saleDetails.clientName} / {saleDetails.customerDetail?.loginUserName}
                                    </span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Amount : <span style={{ fontWeight: 600 }}>{saleDetails.amount}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Status : <span style={{ fontWeight: 600 }}>{saleDetails.statusName}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Package Name : <span style={{ fontWeight: 600 }}>{saleDetails.packageName}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Third Party Name : <span style={{ fontWeight: 600 }}>{saleDetails.thirdPartyName}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Third Party Charges : <span style={{ fontWeight: 600 }}>{saleDetails.thirdPartyCharges}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Third Party Charges Type :{' '}
                                    <span style={{ fontWeight: 600 }}>{saleDetails.thirdPartyChargesTypeName}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Estimated Profit : <span style={{ fontWeight: 600 }}>{saleDetails.estimatedProfit}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Estimated Daily Profit Profit :{' '}
                                    <span style={{ fontWeight: 600 }}>{saleDetails.estimatedDailyProfit}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Converted Amount : <span style={{ fontWeight: 600 }}>{saleDetails.convertedAmountString}</span>
                                </Typography>
                            </Grid>

                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Top Up Amount : <span style={{ fontWeight: 600 }}>{saleDetails.topUpAmount}</span>
                                </Typography>
                            </Grid>

                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Top Up Type : <span style={{ fontWeight: 600 }}>{saleDetails.topUpTypeName}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    ROI Date :
                                    <span style={{ fontWeight: 600 }}>
                                        {saleDetails.roiDate &&
                                            `${saleDetails.roiDate?.split('T')[0]} 
                                            ${new Date('1970-01-01T' + saleDetails.roiDate?.split('T')[1] + 'Z').toLocaleTimeString(
                                                'en-US',
                                                {
                                                    timeZone: 'UTC',
                                                    hour12: true,
                                                    hour: 'numeric',
                                                    minute: 'numeric',
                                                    second: 'numeric'
                                                }
                                            )}`}
                                    </span>
                                </Typography>
                            </Grid>

                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Created By : <span style={{ fontWeight: 600 }}>{saleDetails.createdBy}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Created Date :{' '}
                                    <span style={{ fontWeight: 600 }}>
                                        {saleDetails.createdDate &&
                                            `${saleDetails.createdDate?.split('T')[0]} 
                  ${new Date('1970-01-01T' + saleDetails.createdDate?.split('T')[1] + 'Z').toLocaleTimeString('en-US', {
                      timeZone: 'UTC',
                      hour12: true,
                      hour: 'numeric',
                      minute: 'numeric',
                      second: 'numeric'
                  })}`}
                                    </span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Updated By : <span style={{ fontWeight: 600 }}>{saleDetails.updatedBy}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Updated Date :{' '}
                                    <span style={{ fontWeight: 600 }}>
                                        {saleDetails.updatedDate &&
                                            `${saleDetails.updatedDate?.split('T')[0]} 
                  ${new Date('1970-01-01T' + saleDetails.updatedDate?.split('T')[1] + 'Z').toLocaleTimeString('en-US', {
                      timeZone: 'UTC',
                      hour12: true,
                      hour: 'numeric',
                      minute: 'numeric',
                      second: 'numeric'
                  })}`}
                                    </span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    User Name : <span style={{ fontWeight: 600 }}>{saleDetails.userName}</span>
                                </Typography>
                            </Grid>

                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Approved Date :{' '}
                                    <span style={{ fontWeight: 600 }}>
                                        {saleDetails.approvedDate &&
                                            `${saleDetails.approvedDate?.split('T')[0]} 
                                            ${new Date('1970-01-01T' + saleDetails.approvedDate?.split('T')[1] + 'Z').toLocaleTimeString(
                                                'en-US',
                                                {
                                                    timeZone: 'UTC',
                                                    hour12: true,
                                                    hour: 'numeric',
                                                    minute: 'numeric',
                                                    second: 'numeric'
                                                }
                                            )}`}
                                    </span>
                                </Typography>
                            </Grid>
                            {saleDetails?.customerDetail && (
                                <>
                                    <Grid item container xs={12} md={12} sx={{ mt: 3 }}>
                                        <Typography
                                            sx={{
                                                fontSize: '20px',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            Customer Details
                                        </Typography>
                                    </Grid>

                                    {/* Customer ID */}
                                    <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px'
                                            }}
                                        >
                                            Customer ID : <span style={{ fontWeight: 600 }}>{saleDetails?.customerDetail?.id}</span>
                                        </Typography>
                                    </Grid>

                                    {/* Name */}
                                    <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px'
                                            }}
                                        >
                                            Name : <span style={{ fontWeight: 600 }}>{saleDetails?.customerDetail?.name}</span>
                                        </Typography>
                                    </Grid>

                                    {/* Bank Vendor ID */}
                                    <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px'
                                            }}
                                        >
                                            Bank Vendor ID :{' '}
                                            <span style={{ fontWeight: 600 }}>{saleDetails?.customerDetail?.bankVendorID}</span>
                                        </Typography>
                                    </Grid>

                                    {/* Bank Vendor Name */}
                                    <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px'
                                            }}
                                        >
                                            Bank Vendor Name :{' '}
                                            <span style={{ fontWeight: 600 }}>{saleDetails?.customerDetail?.bankVendorName}</span>
                                        </Typography>
                                    </Grid>

                                    {/* Bank Account */}
                                    <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px'
                                            }}
                                        >
                                            Bank Account :{' '}
                                            <span style={{ fontWeight: 600 }}>{saleDetails?.customerDetail?.bankAccount}</span>
                                        </Typography>
                                    </Grid>

                                    {/* Bank Holder Name */}
                                    <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px'
                                            }}
                                        >
                                            Bank Holder Name :{' '}
                                            <span style={{ fontWeight: 600 }}>{saleDetails?.customerDetail?.bankHolderName}</span>
                                        </Typography>
                                    </Grid>

                                    {/* Phone Number */}
                                    <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px'
                                            }}
                                        >
                                            Phone Number :{' '}
                                            <span style={{ fontWeight: 600 }}>{saleDetails?.customerDetail?.phoneNumber}</span>
                                        </Typography>
                                    </Grid>

                                    {/* Phone Number */}
                                    <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px'
                                            }}
                                        >
                                            Recommend By :{' '}
                                            <span style={{ fontWeight: 600 }}>{saleDetails?.customerDetail?.recommendBy}</span>
                                        </Typography>
                                    </Grid>

                                    {/* NRC */}
                                    <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px'
                                            }}
                                        >
                                            NRC : <span style={{ fontWeight: 600 }}>{saleDetails?.customerDetail?.nrc}</span>
                                        </Typography>
                                    </Grid>

                                    {/* Birthday */}
                                    <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px'
                                            }}
                                        >
                                            Birthday : <span style={{ fontWeight: 600 }}>{saleDetails?.customerDetail?.birthday}</span>
                                        </Typography>
                                    </Grid>

                                    {/* Username */}
                                    <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px'
                                            }}
                                        >
                                            Username : <span style={{ fontWeight: 600 }}>{saleDetails?.customerDetail?.userName}</span>
                                        </Typography>
                                    </Grid>

                                    {/* Customer Status */}
                                    <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px'
                                            }}
                                        >
                                            Customer Status :{' '}
                                            <span style={{ fontWeight: 600 }}>{saleDetails?.customerDetail?.customerStatusName}</span>
                                        </Typography>
                                    </Grid>

                                    {/* Total Deposit Amount */}
                                    <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px'
                                            }}
                                        >
                                            Total Deposit Amount :{' '}
                                            <span style={{ fontWeight: 600 }}>{saleDetails?.customerDetail?.totalDepositAmount}</span>
                                        </Typography>
                                    </Grid>

                                    {/* Total Payout Amount */}
                                    <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px'
                                            }}
                                        >
                                            Total Payout Amount :{' '}
                                            <span style={{ fontWeight: 600 }}>{saleDetails?.customerDetail?.totalPayoutAmount}</span>
                                        </Typography>
                                    </Grid>

                                    {/* Total PNL Amount */}
                                    <Grid item container xs={12} md={6} sx={{ my: 2 }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px'
                                            }}
                                        >
                                            Total PNL Amount :{' '}
                                            <span style={{ fontWeight: 600 }}>{saleDetails?.customerDetail?.totalPNLAmount}</span>
                                        </Typography>
                                    </Grid>

                                    {/* Last Sales Records */}
                                    {saleDetails?.customerDetail?.lastSalesRecords.length !== 0 && (
                                        <Grid item container xs={12} md={12} sx={{ mt: 2 }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '18px',
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                                Customer' Last Sales Records
                                            </Typography>
                                        </Grid>
                                    )}

                                    {/* Last Sales Records List */}
                                    {saleDetails?.customerDetail?.lastSalesRecords?.map((item, index) => {
                                        return (
                                            <Grid
                                                key={index}
                                                item
                                                container
                                                xs={12}
                                                md={12}
                                                pb={2}
                                                sx={{ borderBottom: '1px dashed gray' }}
                                            >
                                                <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                                    <Typography
                                                        sx={{
                                                            fontSize: '16px'
                                                        }}
                                                    >
                                                        Amount : <span style={{ fontWeight: 600 }}>{item.amount}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                                    <Typography
                                                        sx={{
                                                            fontSize: '16px'
                                                        }}
                                                    >
                                                        Converted Amount : <span style={{ fontWeight: 600 }}>{item.convertedAmount}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                                    <Typography
                                                        sx={{
                                                            fontSize: '16px'
                                                        }}
                                                    >
                                                        Status Name : <span style={{ fontWeight: 600 }}>{item.statusName}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                                    <Typography
                                                        sx={{
                                                            fontSize: '16px'
                                                        }}
                                                    >
                                                        Package Name : <span style={{ fontWeight: 600 }}>{item.packageName}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                                    <Typography
                                                        sx={{
                                                            fontSize: '16px'
                                                        }}
                                                    >
                                                        Estimated Daily Profit :{' '}
                                                        <span style={{ fontWeight: 600 }}>{item.estimatedDailyProfit}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                                    <Typography
                                                        sx={{
                                                            fontSize: '16px'
                                                        }}
                                                    >
                                                        Estimated Profit : <span style={{ fontWeight: 600 }}>{item.estimatedProfit}</span>
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        );
                                    })}

                                    {/* Last Payout Records List */}
                                    <Grid item container xs={12} sx={{ mt: 3 }}>
                                        <Typography
                                            sx={{
                                                fontSize: '18px',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            Customer' Last Payout Records
                                        </Typography>
                                        <LastPayoutRecords
                                            lastPayoutRecords={
                                                saleDetails?.customerDetail?.lastPayoutRecords
                                                    ? saleDetails?.customerDetail?.lastPayoutRecords
                                                    : []
                                            }
                                        />
                                    </Grid>

                                    {/* Wallet List */}
                                    <Grid item container xs={12} sx={{ mt: 3 }}>
                                        <Typography
                                            sx={{
                                                fontSize: '18px',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            Customer' Wallet
                                        </Typography>
                                        <Wallets
                                            wallets={saleDetails?.customerDetail?.wallets ? saleDetails?.customerDetail?.wallets : []}
                                        />
                                    </Grid>
                                </>
                            )}
                        </Grid>
                    </Box>
                </Box>
            </Modal>
        </div>
    );
};

const SalesRecord = () => {
    const user = useSelector(selectCurrentUser);
    const token = useSelector(selectCurrentToken);
    const theme = useTheme();
    // const [expensesTypes, setExpensesTypes] = useState([]);
    // const [thirdparty, setThirdParty] = useState([]);
    // const [topUpTypeList, setTopUpTypeList] = useState([]);
    // const [packages, setPackages] = useState([]);
    // const [saleStatus, setSalesStatus] = useState([]);
    const [sales, setSales] = useState([]);
    // console.log('sales list', sales);
    const [filterSalesFrom, setFilerSalesFrom] = useState(dayjs().subtract(1, 'days'));
    const [filterSalesRoi, setFilerSalesRoi] = useState('');
    const [filterSalesTo, setFilerSalesTo] = useState(dayjs());
    const [filterSalesClientName, setFilterSalesClientName] = useState('');
    const [filterSalesClientLoginUserName, setFilterSalesClientLoginUserName] = useState('');
    const [filterSalesUserName, setFilterSalesUserName] = useState('');
    const [filterSalesStatus, setFilterSalesStatus] = useState('');
    const [filterSalesPackage, setFilterSalesPackage] = useState('');
    const [filterSalesThirdParty, setFilterSalesThirdParty] = useState('');
    const [filterSalesCustomerID, setFilterSalesCustomerID] = useState('');
    const [filterSalesTopUpTypeID, setFilterSalesTopUpTypeID] = useState('');
    const [filterSalesApprovedDateFrom, setFilterSalesApprovedDateFrom] = useState('');
    const [filterSalesApprovedDateTo, setFilterSalesApprovedDateTo] = useState('');
    const [filterSalesPackageTypeID, setFilterSalesPackageTypeID] = useState('');
    const [filterSalesPackageEndDate, setFilterSalesPackageEndDate] = useState('');
    const [transactionNumber, setTransactionNumber] = useState('');
    const [filterSalesIsRecommend, setFilterSalesIsRecommend] = useState('');
    const [filterSalesIsMultipleThirdParty, setFilterSalesIsMultipleThirdParty] = useState('');
    const [filterSalesCustomerTypeID, setFilterSalesCustomerTypeID] = useState('');
    // const [customerNameOptions, setCustomerNameOptions] = useState([]);
    // const [usersList, setUsersList] = useState([]);
    // const [currencies, setCurrencies] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [isAllowFilterUserName, setIsAllowFilterUserName] = useState();
    const [filterBtnDisabled, setFilterBtnDisabled] = useState(false);
    const [filterIsLock, setFilterIsLock] = useState('all');

    const warningAlert = (message) => {
        toast.warning(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const successAlert = (message) => {
        toast.success(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const errorAlert = (message) => {
        toast.error(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const [isAllowedTransaction, setIsAllowedTransaction] = useState();
    //fetch customer names for autocomplete start
    const fetchIsAllowedTransaction = async () => {
        try {
            const res = await axiosInstance.get('/IsAllowed/Transaction', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setIsAllowedTransaction(res.data);
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch customer names for autocomplete end

    const { data: customerNameOptions, error: expensesTypesError } = useFetchData('/Customer/Names');
    const { data: customerLoginUserNameOptions } = useFetchData('/Customer/LoginUserNames');
    const { data: usersList } = useFetchData('/Usernames');
    const { data: expensesTypes } = useFetchData('/ExpensesType');
    const { data: packages } = useFetchData('/AvailablePackage');
    const { data: thirdparty } = useFetchData('/ThirdParty');
    const { data: topUpTypeList } = useFetchData('/TopUpType/All');
    const { data: saleStatus } = useFetchData('/SalesStatus');
    const { data: currencies } = useFetchData('/Currency');
    const { data: thirdPartyTransactionLimitList } = useFetchData('/ThirdPartyTransactionLimit/Current');
    const { data: packageTypeList } = useFetchData('/Backend/PackageTypes/All');

    const fetchIsAllowFilterUserName = async () => {
        try {
            const res = await axiosInstance.get(`/isAllowFilterUserName`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setIsAllowFilterUserName(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };

    const [fetchSalesLoading, setFetchSalesLoading] = useState(false);
    const [updateLock, setUpdateLock] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const [prevPages, setPrevPages] = useState([]);
    const [newPage, setNewPage] = useState(0);

    // const handleChangePage = (event, newPage) => {
    //     // Check if newPage is greater than or equal to the current page
    //     if (newPage >= page) {
    //         // Set the page state
    //         setPage(newPage);

    //         // Check if the new page is not in the list of previously fetched pages
    //         if (!prevPages.includes(newPage)) {
    //             // If it's not, add it to the list and fetch the data
    //             setPrevPages((prevPages) => [...prevPages, newPage]);
    //             setNewPage(newPage); // Update the newPage state
    //         }
    //     } else {
    //         // If newPage is less than the current page, just set the page state without fetching new data
    //         setPage(newPage);
    //     }
    // };

    // const handleChangeRowsPerPage = (event) => {
    //     setRowsPerPage(+event.target.value);
    //     setPrevPages([]);
    //     setSales([]);
    //     setPage(0);
    // };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    //fetch sales start
    const fetchSales = async () => {
        setSales([]);
        setFetchSalesLoading(true);
        if (!filterSalesFrom.isValid() || !filterSalesTo.isValid()) {
            warningAlert('Please fill all required fields.');
            return;
        }
        let salesURL = `/Sales/All?createdDateFrom=${filterSalesFrom.format('YYYY-MM-DD')}&createdDateTo=${filterSalesTo.format(
            'YYYY-MM-DD'
        )}`;
        // let salesURL = `/Sales/All?createdDateFrom=2023-01-01&createdDateTo=2023-12-1&pageIndex=${page}&pageSize=${rowsPerPage}`;
        if (filterSalesClientName !== '') {
            salesURL += `&clientName=${filterSalesClientName}`;
        }
        if (filterSalesClientLoginUserName !== '') {
            salesURL += `&loginUserName=${filterSalesClientLoginUserName}`;
        }
        if (filterSalesUserName !== '') {
            salesURL += `&searchUserID=${parseInt(filterSalesUserName, 10)}`;
        }
        if (filterSalesStatus !== '') {
            salesURL += `&statusID=${filterSalesStatus}`;
        }
        if (filterSalesPackage !== '') {
            salesURL += `&packageID=${filterSalesPackage}`;
        }
        if (transactionNumber !== '') {
            salesURL += `&transactionNumber=${transactionNumber}`;
        }
        if (filterSalesThirdParty !== '') {
            salesURL += `&thirdPartyID=${filterSalesThirdParty}`;
        }

        if (filterSalesRoi !== '') {
            const formattedDate = dayjs(filterSalesRoi).format('YYYY-MM-DD'); // Format the date as needed
            salesURL += `&roiDate=${formattedDate}`;
        }

        if (filterIsLock !== 'all') {
            if (filterIsLock === 'lock') {
                salesURL += `&isLock=true`;
            }
            if (filterIsLock === 'notlock') {
                salesURL += `&isLock=false`;
            }
        }

        if (filterSalesCustomerID !== '') {
            salesURL += `&numberCode=${filterSalesCustomerID}`;
        }
        if (filterSalesTopUpTypeID !== '') {
            salesURL += `&topUpTypeID=${filterSalesTopUpTypeID}`;
        }

        if (filterSalesApprovedDateFrom !== '' && filterSalesApprovedDateFrom !== null) {
            salesURL += `&approvedDateFrom=${filterSalesApprovedDateFrom.format('YYYY-MM-DD')}`;
        }

        if (filterSalesApprovedDateTo !== '' && filterSalesApprovedDateTo !== null) {
            salesURL += `&approvedDateTo=${filterSalesApprovedDateTo.format('YYYY-MM-DD')}`;
        }

        if (filterSalesPackageTypeID !== '' && filterSalesPackageTypeID !== null) {
            salesURL += `&packageTypeID=${filterSalesPackageTypeID}`;
        }

        if (filterSalesPackageEndDate !== '' && filterSalesPackageEndDate !== null) {
            salesURL += `&packageEndDate=${filterSalesPackageEndDate.format('YYYY-MM-DD')}`;
        }

        if (filterSalesIsRecommend !== '') {
            salesURL += `&isRecommendBy=${filterSalesIsRecommend}`;
        }

        if (filterSalesIsMultipleThirdParty !== '') {
            salesURL += `&isMultipleThirdParty=${filterSalesIsMultipleThirdParty}`;
        }

        if (filterSalesCustomerTypeID !== '') {
            salesURL += `&customerTypeID=${filterSalesCustomerTypeID}`;
        }

        setFilterBtnDisabled(true);
        try {
            const res = await axiosInstance.get(salesURL, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                // setSales(res.data);
                setSales((sales) => [...sales, ...res.data]);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setFetchSalesLoading(false);
            setFilterBtnDisabled(false);
        }
    };

    useEffect(() => {
        fetchSales();
        fetchIsUserAllowEdit();
    }, [newPage, rowsPerPage]);

    const [exportDataListLoading, setExportDataListLoading] = useState(false);
    function convertDataForSheet(data) {
        if (!data || data.length === 0) {
            warningAlert('There is no data to export');
            throw new Error('Data array is empty or undefined.');
        }

        const headers = Object.keys(data[0]);
        const dataArray = [headers];

        data.forEach((item) => {
            const row = headers.map((key) => item[key]);
            dataArray.push(row);
        });

        return XLSX.utils.aoa_to_sheet(dataArray);
    }
    const exportDataAsXlsx = async () => {
        setFilterBtnDisabled(true);
        setTimeout(() => {
            setFilterBtnDisabled(false);
        }, 3000);
        setExportDataListLoading(true);
        if (!filterSalesFrom.isValid() || !filterSalesTo.isValid()) {
            warningAlert('Please fill all required fields.');
            return;
        }

        // Construct the sales URL with the new parameters
        let salesURL = `/Sales/All?createdDateFrom=${filterSalesFrom.format('YYYY-MM-DD')}&createdDateTo=${filterSalesTo.format(
            'YYYY-MM-DD'
        )}`;
        // createdDateTo=${filterSalesTo.format('YYYY-MM-DD')}&pageIndex=${page}&pageSize=${rowsPerPage}`;

        if (filterSalesClientName !== '') {
            salesURL += `&clientName=${filterSalesClientName}`;
        }
        if (filterSalesClientLoginUserName !== '') {
            salesURL += `&loginUserName=${filterSalesClientLoginUserName}`;
        }
        if (filterSalesUserName !== '') {
            salesURL += `&searchUserID=${parseInt(filterSalesUserName, 10)}`;
        }
        if (filterSalesStatus !== '') {
            salesURL += `&statusID=${filterSalesStatus}`;
        }
        if (filterSalesPackage !== '') {
            salesURL += `&packageID=${filterSalesPackage}`;
        }
        if (transactionNumber !== '') {
            salesURL += `&transactionNumber=${transactionNumber}`;
        }
        if (filterSalesThirdParty !== '') {
            salesURL += `&thirdPartyID=${filterSalesThirdParty}`;
        }

        if (filterSalesRoi !== '') {
            const formattedDate = dayjs(filterSalesRoi).format('YYYY-MM-DD'); // Format the date as needed
            salesURL += `&roiDate=${formattedDate}`;
        }

        if (filterIsLock !== 'all') {
            if (filterIsLock === 'lock') {
                salesURL += `&isLock=true`;
            }
            if (filterIsLock === 'notlock') {
                salesURL += `&isLock=false`;
            }
        }

        if (filterSalesCustomerID !== '') {
            salesURL += `&numberCode=${filterSalesCustomerID}`;
        }
        if (filterSalesTopUpTypeID !== '') {
            salesURL += `&topUpTypeID=${filterSalesTopUpTypeID}`;
        }

        if (filterSalesApprovedDateFrom !== '' && filterSalesApprovedDateFrom !== null) {
            salesURL += `&approvedDateFrom=${filterSalesApprovedDateFrom.format('YYYY-MM-DD')}`;
        }

        if (filterSalesApprovedDateTo !== '' && filterSalesApprovedDateTo !== null) {
            salesURL += `&approvedDateTo=${filterSalesApprovedDateTo.format('YYYY-MM-DD')}`;
        }

        if (filterSalesPackageTypeID !== '' && filterSalesPackageTypeID !== null) {
            salesURL += `&packageTypeID=${filterSalesPackageTypeID}`;
        }

        if (filterSalesPackageEndDate !== '' && filterSalesPackageEndDate !== null) {
            salesURL += `&packageEndDate=${filterSalesPackageEndDate.format('YYYY-MM-DD')}`;
        }

        if (filterSalesIsRecommend !== '') {
            salesURL += `&isRecommendBy=${filterSalesIsRecommend}`;
        }

        if (filterSalesIsMultipleThirdParty !== '') {
            salesURL += `&isMultipleThirdParty=${filterSalesIsMultipleThirdParty}`;
        }

        if (filterSalesCustomerTypeID !== '') {
            salesURL += `&customerTypeID=${filterSalesCustomerTypeID}`;
        }

        try {
            const res = await axiosInstance.get(salesURL, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                const fileName = `SalesRecord_${dayjs().format('MM-DD-YYYY')}`;
                const workbook = XLSX.utils.book_new();
                const worksheet = convertDataForSheet(
                    res.data.map(
                        ({
                            id,
                            createdBy,
                            customerType,
                            recommendBy,
                            clientName,
                            loginUserName,
                            phoneNumber,
                            bankVendorName,
                            bankAccountHolderName,
                            bankAccountNumber,
                            packageName,
                            packagePercentageString,
                            amount,
                            topUpAmount,
                            totalAmount,
                            topUpTypeName,
                            estimatedDailyProfit,
                            packageStartDate,
                            packageEndDate,
                            refundDate,
                            thirdPartyName,
                            transactionNumber,
                            multipleThirdPartyName,
                            multipleThirdPartyAmount,
                            roiDate,
                            promotionCode,
                            createdDate,
                            cappingProfitAmount,
                            cappingAmount
                        }) => ({
                            id,
                            createdBy,
                            customerType,
                            recommendBy,
                            clientName,
                            loginUserName,
                            phoneNumber,
                            bankVendorName,
                            bankAccountHolderName,
                            bankAccountNumber,
                            packageName,
                            packagePercentageString,
                            amount,
                            topUpAmount,
                            totalAmount,
                            topUpTypeName,
                            estimatedDailyProfit,
                            packageStartDate,
                            packageEndDate,
                            refundDate,
                            thirdPartyName,
                            transactionNumber,
                            multipleThirdPartyName,
                            multipleThirdPartyAmount,
                            roiDate,
                            promotionCode,
                            createdDate,
                            cappingProfitAmount,
                            cappingAmount
                        })
                    )
                );
                // Adjust column widths
                const headers = Object.keys(res.data[0]);
                const colWidths = headers.map((header) => ({ wch: header.length + 2 }));

                worksheet['!cols'] = colWidths;

                XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
                XLSX.writeFile(workbook, `${fileName}.xlsx`);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setExportDataListLoading(false);
        }
    };

    //fetch sales end

    const [isUserAllowEdit, setIsUserAllowEdit] = useState(false);
    const fetchIsUserAllowEdit = async () => {
        try {
            const res = await axiosInstance.get('IsAllowEdit', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setIsUserAllowEdit(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };

    //insert sales start
    const InsertSalesRecord = () => {
        const [open, setOpen] = useState(false);
        const handleOpen = () => setOpen(true);
        const handleClose = () => setOpen(false);
        const [salesData, setSalesData] = useState([{ thirdPartyID: '', amount: '' }]);

        const handleAddRow = () => {
            setSalesData([...salesData, { thirdPartyID: '', amount: '' }]);
        };

        const removeRow = (index) => {
            const updatedSales = salesData.filter((_, i) => i !== index);
            setSalesData(updatedSales);
        };

        const handleInputChange = (index, field, value) => {
            const updatedSales = [...salesData];
            updatedSales[index][field] = value;
            setSalesData(updatedSales);
        };
        const [insertSalesClientName, setInsertSalesClientName] = useState('');
        const [insertSalesCustomerLoginUserName, setInsertSalesCustomerLoginUserName] = useState('');
        const [insertSalesAmount, setInsertSalesAmount] = useState(0);
        const [insertSalesStatus, setInsertSalesStatus] = useState('');
        const [insertSalesPackage, setInsertSalesPackage] = useState('');
        const [insertSalesThirdParty, setInsertSalesThirdParty] = useState('');
        const [insertSalesCurrency, setInsertSalesCurrency] = useState('');
        const [insertSalesTopUpType, setInsertSalesTopUpType] = useState('');
        const [insertSalesCurrencyAmount, setInsertSalesCurrencyAmount] = useState(0);
        const [insertSalesTopUpAmount, setInsertSalesTopUpAmount] = useState(0);
        const [insertTransactionNumber, setInsertTransactionNumber] = useState('');
        const [insertSalesConvertedRate, setInsertSalesConvertedRate] = useState(0);

        const [insertBtnDisabled, setInsertBtnDisabled] = useState(false);
        const [insertSalesLoading, setInsertSalesLoading] = useState(false);

        //fetch Non Payment Date start
        const [fetchCurrentTransactionLimitLoading, setCurrentTransactionLimitLoading] = useState(false);
        const [currenttransactionLimit, setCurrentTransactionLimit] = useState(0);

        const [fetchCustomerDepositLimitLoading, setFetchCustomerDepositLimitLoading] = useState(false);
        const [currentDepositLimit, setCurrentDepositLimit] = useState(0);

        const fetchCustomerDepositLimit = async (customerLoginUserName) => {
            setFetchCustomerDepositLimitLoading(true);

            try {
                const url = `/Backend/Customer/DepositLimit/Today?customerLoginUserName=${customerLoginUserName}`;
                const res = await axiosInstance.get(`${url}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                if (res.status === 200) {
                    setCurrentDepositLimit(res.data);
                } else {
                    console.log('Fail', res.data);
                    errorAlert('Something Went Wrong');
                }
            } catch (error) {
                console.log('Failed', error);
                console.log(error);
            } finally {
                setFetchCustomerDepositLimitLoading(false);
            }
        };

        const fetchCurrentTransactionLimit = async (thirdPartyID) => {
            setCurrentTransactionLimitLoading(true);

            try {
                const url = `/ThirdPartyTransactionLimit/Current/${parseInt(thirdPartyID)}`;
                const res = await axiosInstance.get(`${url}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                if (res.status === 200) {
                    setCurrentTransactionLimit(res.data);
                } else if (res.status === 204) {
                    setCurrentTransactionLimit(-1);
                    // errorAlert('No Transaction content found');
                } else {
                    console.log('Fail', res.data);
                    errorAlert('Something Went Wrong');
                }
            } catch (error) {
                console.log('Failed', error);
                console.log(error);
            } finally {
                setCurrentTransactionLimitLoading(false);
            }
        };

        //fetch Non Payment Date end

        const handleThirdPartyIdChange = (id) => {
            setInsertSalesThirdParty(id);
            fetchCurrentTransactionLimit(id);
        };

        const handleCustomerLoginUserNameChange = (newValue) => {
            setInsertSalesCustomerLoginUserName(newValue);
            fetchCustomerDepositLimit(newValue);
        };

        const submitInsertSales = async (e) => {
            setInsertBtnDisabled(true);
            setTimeout(() => {
                setInsertBtnDisabled(false);
            }, 3000);

            // console.log('topUpTypeID', insertSalesTopUpType);
            // console.log('topUpAmount', insertSalesTopUpAmount);

            if (
                insertSalesCustomerLoginUserName === '' ||
                // parseFloat(insertSalesAmount) === 0 ||
                insertSalesStatus === ''
                // insertSalesPackage === "" ||
                // insertSalesThirdParty === ""
            ) {
                warningAlert('Please fill all required fields.');
                return;
            }

            setInsertSalesLoading(true);
            try {
                const validSalesData = salesData.filter((item) => item.thirdPartyID !== '' && item.amount !== '');

                // if (validSalesData.length === 0) {
                //     errorAlert("Please select a third party and enter the amount.");
                //     setInsertSalesLoading(false);
                //     return;
                // }
                const res = await axiosInstance.post(
                    '/Sales',
                    {
                        customerLoginUserName: insertSalesCustomerLoginUserName,
                        amount: parseFloat(insertSalesAmount),
                        statusID: insertSalesStatus,
                        packageID: insertSalesPackage,
                        thirdPartyID: insertSalesThirdParty,
                        convertedCurrencyID: insertSalesCurrency,
                        convertedAmount: parseFloat(insertSalesCurrencyAmount),
                        convertedRate: parseFloat(insertSalesConvertedRate),
                        topUpTypeID: parseFloat(insertSalesTopUpType),
                        topUpAmount: parseFloat(insertSalesTopUpAmount),
                        transactionNumber: insertTransactionNumber,
                        salesAmountByThirdParty: validSalesData.map((item) => ({
                            thirdPartyID: parseInt(item.thirdPartyID),
                            amount: parseFloat(item.amount)
                        }))
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    successAlert('Sales created successfully.');
                    fetchSales();
                } else {
                    if (res.response.data.errorCode) {
                        const errorCode = res.response.data.errorCode;

                        if (errorCode === 'DEP0002') {
                            errorAlert(res.response.data.errorMessage);
                        } else {
                            errorAlert('Something went wrong.');
                        }
                    } else {
                        errorAlert('Something went wrong.');
                    }
                }
            } catch (error) {
                console.log(error);
            } finally {
                setInsertSalesLoading(false);
            }
        };

        return (
            <>
                <Button
                    onClick={handleOpen}
                    sx={{
                        border: 'none',
                        backgroundColor: deepPurple[500],
                        color: 'white',
                        marginLeft: 'auto',
                        marginBottom: '20px',
                        marginRight: '20px'
                    }}
                >
                    Insert Sale
                </Button>

                <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    {insertSalesLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box sx={style}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Typography id="modal-modal-title" variant="h3" component="h2">
                                    Insert Sale
                                </Typography>
                                <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                            </Box>
                            <Box
                                id="modal-modal-description"
                                sx={{
                                    height: '450px',
                                    overflowY: 'auto'
                                }}
                            >
                                <Grid item container xs={12} sx={{ mt: 2 }}>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Customer Login User Name :
                                            </Typography>
                                            <Autocomplete
                                                freeSolo
                                                value={insertSalesCustomerLoginUserName}
                                                onChange={(event, newValue) => handleCustomerLoginUserNameChange(newValue)}
                                                // onChange={(event, newValue) => {
                                                //     setInsertSalesCustomerLoginUserName(newValue);
                                                // }}
                                                inputValue={insertSalesCustomerLoginUserName}
                                                onInputChange={(event, newInputValue) => handleCustomerLoginUserNameChange(newInputValue)}
                                                // onInputChange={(event, newInputValue) => {
                                                //     setInsertSalesCustomerLoginUserName(newInputValue);
                                                // }}
                                                id="controllable-states-demo"
                                                options={customerLoginUserNameOptions}
                                                sx={{ width: 170 }}
                                                renderInput={(params) => <TextField {...params} />}
                                                disableClearable
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Amount :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={insertSalesAmount}
                                                onChange={(e) => setInsertSalesAmount(e.target.value)}
                                            />
                                            <Typography
                                                variant="h3"
                                                component="h2"
                                                sx={{
                                                    fontSize: '14px',
                                                    whiteSpace: 'nowrap',
                                                    margin: '10px'
                                                }}
                                            >
                                                Deposit Limit :{' '}
                                                {currentDepositLimit === -1 ? (
                                                    <Box sx={{ color: 'green' }}>
                                                        {fetchCustomerDepositLimitLoading ? (
                                                            <Box sx={{ color: grey }}>Loading...</Box>
                                                        ) : (
                                                            'No Limit'
                                                        )}
                                                    </Box>
                                                ) : (
                                                    currentDepositLimit
                                                )}
                                            </Typography>
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                {/* <span style={{ color: "red" }}>*</span> */}
                                                Package Name :
                                            </Typography>
                                            <Select
                                                displayEmpty
                                                value={insertSalesPackage}
                                                onChange={(e) => setInsertSalesPackage(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value="">
                                                    Select Package
                                                </MenuItem>
                                                {packages.map((item, index) => (
                                                    <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Status :
                                            </Typography>
                                            <Select
                                                displayEmpty
                                                value={insertSalesStatus}
                                                onChange={(e) => setInsertSalesStatus(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value="">
                                                    Select Status
                                                </MenuItem>
                                                {saleStatus.map((item, index) => (
                                                    <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                {/* <span style={{ color: "red" }}>*</span> */}
                                                Third Party :
                                            </Typography>
                                            <Select
                                                displayEmpty
                                                value={insertSalesThirdParty}
                                                onChange={(e) => handleThirdPartyIdChange(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value="">
                                                    Select Third Party
                                                </MenuItem>
                                                {thirdparty.map((item, index) => (
                                                    <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>
                                        <Typography
                                            variant="h3"
                                            component="h2"
                                            sx={{
                                                fontSize: '14px',
                                                whiteSpace: 'nowrap',
                                                margin: '10px'
                                            }}
                                        >
                                            Current Transaction Limit :{' '}
                                            {currenttransactionLimit === -1 ? (
                                                <Box sx={{ color: 'green' }}>
                                                    {fetchCurrentTransactionLimitLoading ? (
                                                        <Box sx={{ color: grey }}>Loading...</Box>
                                                    ) : (
                                                        'No Limit'
                                                    )}
                                                </Box>
                                            ) : (
                                                currenttransactionLimit
                                            )}
                                        </Typography>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px'
                                                    // whiteSpace:"nowrap",
                                                }}
                                            >
                                                Converted Currency :
                                            </Typography>
                                            <Select
                                                displayEmpty
                                                value={insertSalesCurrency}
                                                onChange={(e) => setInsertSalesCurrency(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value="">
                                                    Select Currency
                                                </MenuItem>
                                                {currencies.map((item, index) => (
                                                    <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px'
                                                    // whiteSpace:"nowrap",
                                                }}
                                            >
                                                Converted Currency Amount :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={insertSalesCurrencyAmount}
                                                onChange={(e) => setInsertSalesCurrencyAmount(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px'
                                                    // whiteSpace:"nowrap",
                                                }}
                                            >
                                                Converted Currency Rate :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={insertSalesConvertedRate}
                                                onChange={(e) => setInsertSalesConvertedRate(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                {/* <span style={{ color: "red" }}>*</span> */}
                                                Top Up Type :
                                            </Typography>
                                            <Select
                                                displayEmpty
                                                value={insertSalesTopUpType}
                                                onChange={(e) => setInsertSalesTopUpType(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value="">
                                                    Select Top Up Type
                                                </MenuItem>
                                                {topUpTypeList.map((item, index) => (
                                                    <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px'
                                                    // whiteSpace:"nowrap",
                                                }}
                                            >
                                                Top Up Amount :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={insertSalesTopUpAmount}
                                                onChange={(e) => setInsertSalesTopUpAmount(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={12} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px'
                                                    // whiteSpace:"nowrap",
                                                }}
                                            >
                                                Transaction Number :
                                            </Typography>
                                            <input
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={insertTransactionNumber}
                                                onChange={(e) => setInsertTransactionNumber(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    {salesData.map((data, index) => (
                                        <>
                                            <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <Typography
                                                        sx={{
                                                            fontSize: '16px',
                                                            whiteSpace: 'nowrap'
                                                        }}
                                                    >
                                                        Third Party :
                                                    </Typography>
                                                    <Select
                                                        displayEmpty
                                                        value={data.thirdPartyID}
                                                        onChange={(e) => handleInputChange(index, 'thirdPartyID', e.target.value)}
                                                    >
                                                        <MenuItem sx={{ width: '100%' }} value="">
                                                            Select Third Party
                                                        </MenuItem>
                                                        {thirdparty.map((item, index) => (
                                                            <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                                {item.name}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </Box>
                                            </Grid>

                                            <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <Typography
                                                        sx={{
                                                            fontSize: '16px'
                                                        }}
                                                    >
                                                        Amount
                                                    </Typography>
                                                    <input
                                                        style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                        value={data.amount}
                                                        onChange={(e) => handleInputChange(index, 'amount', e.target.value)}
                                                        disabled={!data.thirdPartyID}
                                                    />
                                                </Box>
                                                {index === salesData.length - 1 ? (
                                                    <button
                                                        type="button"
                                                        onClick={handleAddRow}
                                                        style={{ width: '10%', height: '50px', borderRadius: '10px', fontSize: '18px' }}
                                                        disabled={!data.thirdPartyID}
                                                    >
                                                        +
                                                    </button>
                                                ) : (
                                                    <button
                                                        type="button"
                                                        onClick={() => removeRow(index)}
                                                        style={{ width: '10%', height: '50px', borderRadius: '10px', fontSize: '18px' }}
                                                    >
                                                        🗑️
                                                    </button>
                                                )}
                                            </Grid>
                                        </>
                                    ))}
                                </Grid>
                            </Box>
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    mx: 'auto',
                                    width: '150px',
                                    backgroundColor: deepPurple[500],
                                    marginTop: '50px'
                                }}
                                onClick={() => submitInsertSales()}
                                disabled={insertBtnDisabled}
                            >
                                Insert Sale
                            </Button>
                        </Box>
                    )}
                </Modal>
            </>
        );
    };
    //insert sales end

    //update sales start
    const UpdateSalesRecord = ({ sale }) => {
        const [open, setOpen] = useState(false);

        // const [salesData, setSalesData] = useState([{ thirdPartyID: '', amount: '' }]);
        const [salesData, setSalesData] = useState(
            sale.salesAmountByThirdParty?.map((data) => ({
                thirdPartyID: data.thirdPartyID || '',
                amount: data.amount || ''
            })) || [{ thirdPartyID: '', amount: '' }]
        );

        console.log('Testing', sale.salesAmountByThirdParty);
        console.log('Testing2', sale);

        const handleAddRow = () => {
            setSalesData([...salesData, { thirdPartyID: '', amount: '' }]);
        };

        const removeRow = (index) => {
            const updatedSales = salesData.filter((_, i) => i !== index);
            setSalesData(updatedSales);
        };

        const handleInputChange = (index, field, value) => {
            const updatedSales = [...salesData];
            updatedSales[index][field] = value;
            setSalesData(updatedSales);
        };

        const handleOpen = () => {
            console.log(sale);
            fetchCustomerDepositLimit();
            setOpen(true);
        };
        // const handleOpen = () => setOpen(true);

        const handleClose = () => setOpen(false);
        const [updateSalesAmount, setUpdateSalesAmount] = useState(sale.amount);
        const [updateSalesStatus, setUpdateSalesStatus] = useState(sale.statusID ? sale.statusID : '');
        const [updateSalesPackage, setUpdateSalesPackage] = useState(sale.packageID ? sale.packageID : '');
        const [updateSalesThirdParty, setUpdateSalesThirdParty] = useState(sale.thirdPartyID ? sale.thirdPartyID : '');
        const [updateSalesCurrency, setUpdateSalesCurrency] = useState(sale.convertedCurrencyID ? sale.convertedCurrencyID : '');
        const [updateSalesCurrencyAmount, setUpdateSalesCurrencyAmount] = useState(sale.convertedAmount);
        const [updateSalesConvertedRate, setUpdateSalesConvertedRate] = useState(sale.convertedRate);
        const [updateSalesTopUpAmount, setUpdateSalesTopUpAmount] = useState(sale.topUpAmount);
        const [updateTransactionNumber, setUpdateTransactionNumber] = useState(sale.transactionNumber);
        const [updateSalesTopUpType, setUpdateSalesTopUpType] = useState(sale.topUpTypeID);
        // const [updateSalesAmountByThirdParty, setUpdateSalesAmountByThirdParty] = useState(sale.salesAmountByThirdParty);

        console.log(sale);

        const [updateBtnDisabled, setUpdateBtnDisabled] = useState(false);
        const [updateSalesRecordLoading, setUpateSalesRecordLoading] = useState(false);

        //fetch Non Payment Date start
        const [fetchCurrentTransactionLimitLoading, setCurrentTransactionLimitLoading] = useState(false);
        const [currenttransactionLimit, setCurrentTransactionLimit] = useState(0);

        const [fetchCustomerDepositLimitLoading, setFetchCustomerDepositLimitLoading] = useState(false);
        const [currentDepositLimit, setCurrentDepositLimit] = useState(0);

        const handleThirdPartyIdChange = (id) => {
            setUpdateSalesThirdParty(id);
            fetchCurrentTransactionLimit(id);
        };

        const fetchCurrentTransactionLimit = async (thirdPartyID) => {
            setCurrentTransactionLimitLoading(true);

            try {
                const url = `/ThirdPartyTransactionLimit/Current/${parseInt(thirdPartyID)}`;
                const res = await axiosInstance.get(`${url}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                if (res.status === 200) {
                    setCurrentTransactionLimit(res.data);
                } else if (res.status === 204) {
                    setCurrentTransactionLimit(-1);
                    // errorAlert('No Transaction content found');
                } else {
                    console.log('Fail', res.data);
                    errorAlert('Something Went Wrong');
                }
            } catch (error) {
                console.log('Failed', error);
                console.log(error);
            } finally {
                setCurrentTransactionLimitLoading(false);
            }
        };

        const fetchCustomerDepositLimit = async () => {
            setFetchCustomerDepositLimitLoading(true);

            try {
                const url = `/Backend/Customer/DepositLimit/Today?customerID=${sale.customerID}`;
                const res = await axiosInstance.get(`${url}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                if (res.status === 200) {
                    setCurrentDepositLimit(res.data);
                } else {
                    console.log('Fail', res.data);
                    errorAlert('Something Went Wrong');
                }
            } catch (error) {
                console.log('Failed', error);
                console.log(error);
            } finally {
                setFetchCustomerDepositLimitLoading(false);
            }
        };

        //fetch Non Payment Date end

        const submitUpdateSales = async () => {
            setUpdateBtnDisabled(true);
            setTimeout(() => {
                setUpdateBtnDisabled(false);
            }, 3000);
            if (updateSalesStatus === '') {
                warningAlert('Please fill all required fields.');
                return;
            }
            setUpateSalesRecordLoading(true);
            try {
                const validSalestData = salesData.filter((item) => item.thirdPartyID !== '' && item.amount !== '');

                // if (validSalestData.length === 0) {
                //     errorAlert("Please select a third party and enter the amount.");
                //     setUpateSalesRecordLoading(false);
                //     return;
                // }

                const res = await axiosInstance.put(
                    '/Sales',
                    {
                        salesID: sale.id,
                        // clientName: updateSalesClientName,
                        amount: parseFloat(updateSalesAmount),
                        statusID: updateSalesStatus,
                        packageID: updateSalesPackage,
                        thirdPartyID: updateSalesThirdParty,
                        convertedCurrencyID: updateSalesCurrency,
                        convertedAmount: parseFloat(updateSalesCurrencyAmount),
                        convertedRate: parseFloat(updateSalesConvertedRate),
                        topUpTypeID: parseFloat(updateSalesTopUpType),
                        topUpAmount: parseFloat(updateSalesTopUpAmount),
                        transactionNumber: updateTransactionNumber,
                        salesAmountByThirdParty: validSalestData.map((item) => ({
                            thirdPartyID: parseInt(item.thirdPartyID),
                            amount: parseFloat(item.amount)
                        }))
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    successAlert('Sales updated successfully.');
                    fetchSales();
                } else {
                    if (res.response.data.errorCode) {
                        const errorCode = res.response.data.errorCode;

                        if (errorCode === 'DEP0002') {
                            errorAlert(res.response.data.errorMessage);
                        } else {
                            errorAlert('Something went wrong.');
                        }
                    } else {
                        errorAlert('Something went wrong.');
                    }
                }
            } catch (error) {
                console.log(error);
            } finally {
                setUpateSalesRecordLoading(false);
            }
        };

        return (
            <>
                <Button
                    onClick={handleOpen}
                    sx={{
                        border: 'none',
                        backgroundColor: 'transparent',
                        width: 'fit-content',
                        height: 'fit-content',
                        color: deepPurple[500]
                    }}
                >
                    <ManageAccounts />
                </Button>

                <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    {updateSalesRecordLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box sx={style}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Typography id="modal-modal-title" variant="h3" component="h2">
                                    Update Sales
                                </Typography>
                                <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                            </Box>
                            <Box
                                id="modal-modal-description"
                                sx={{
                                    height: '450px',
                                    overflowY: 'auto'
                                }}
                            >
                                <Grid item container xs={12} sx={{ mt: 2 }}>
                                    {/* Client Name */}
                                    {/* <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                      <Typography
                                          sx={{
                                              fontSize: '16px',
                                              whiteSpace: 'nowrap'
                                          }}
                                      >
                                          <span style={{ color: 'red' }}>*</span>Client Name :
                                      </Typography>
                                      <Autocomplete
                                          freeSolo
                                          value={updateSalesClientName}
                                          onChange={(event, newValue) => {
                                              setUpdateSalesClientName(newValue);
                                          }}
                                          inputValue={updateSalesClientName}
                                          onInputChange={(event, newInputValue) => {
                                              setUpdateSalesClientName(newInputValue);
                                          }}
                                          id="controllable-states-demo"
                                          options={customerNameOptions}
                                          sx={{ width: 170 }}
                                          renderInput={(params) => <TextField {...params} />}
                                          disableClearable
                                      />
                                  </Box>
                              </Grid> */}
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Amount :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={updateSalesAmount}
                                                onChange={(e) => setUpdateSalesAmount(e.target.value)}
                                            />
                                            <Typography
                                                variant="h3"
                                                component="h2"
                                                sx={{
                                                    fontSize: '14px',
                                                    whiteSpace: 'nowrap',
                                                    margin: '10px'
                                                }}
                                            >
                                                Deposit Limit :{' '}
                                                {currentDepositLimit === -1 ? (
                                                    <Box sx={{ color: 'green' }}>
                                                        {fetchCustomerDepositLimitLoading ? (
                                                            <Box sx={{ color: grey }}>Loading...</Box>
                                                        ) : (
                                                            'No Limit'
                                                        )}
                                                    </Box>
                                                ) : (
                                                    currentDepositLimit
                                                )}
                                            </Typography>
                                        </Box>
                                    </Grid>

                                    {/* Package Name */}
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Package Name :
                                            </Typography>
                                            <Select
                                                displayEmpty
                                                value={updateSalesPackage}
                                                onChange={(e) => setUpdateSalesPackage(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value="">
                                                    Select Package
                                                </MenuItem>
                                                {packages.map((item, index) => (
                                                    <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Status :
                                            </Typography>
                                            <Select
                                                displayEmpty
                                                value={updateSalesStatus}
                                                onChange={(e) => setUpdateSalesStatus(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value="">
                                                    Select Status
                                                </MenuItem>
                                                {saleStatus.map((item, index) => (
                                                    <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Third Party :
                                            </Typography>
                                            <Select
                                                displayEmpty
                                                value={updateSalesThirdParty}
                                                onChange={(e) => handleThirdPartyIdChange(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value="">
                                                    Select Third Party
                                                </MenuItem>
                                                {thirdparty.map((item, index) => (
                                                    <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>
                                        <Typography
                                            variant="h3"
                                            component="h2"
                                            sx={{
                                                fontSize: '14px',
                                                whiteSpace: 'nowrap',
                                                margin: '10px'
                                            }}
                                        >
                                            Current Transaction Limit :{' '}
                                            {currenttransactionLimit === -1 ? (
                                                <Box sx={{ color: 'green' }}>
                                                    {fetchCurrentTransactionLimitLoading ? (
                                                        <Box sx={{ color: grey }}>Loading...</Box>
                                                    ) : (
                                                        'No Limit'
                                                    )}
                                                </Box>
                                            ) : (
                                                currenttransactionLimit
                                            )}
                                        </Typography>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px'
                                                    // whiteSpace:"nowrap",
                                                }}
                                            >
                                                Converted Currency :
                                            </Typography>
                                            <Select
                                                displayEmpty
                                                value={updateSalesCurrency}
                                                onChange={(e) => setUpdateSalesCurrency(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value="">
                                                    Select Currency
                                                </MenuItem>
                                                {currencies.map((item, index) => (
                                                    <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px'
                                                    // whiteSpace:"nowrap",
                                                }}
                                            >
                                                Converted Currency Amount :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={updateSalesCurrencyAmount}
                                                onChange={(e) => setUpdateSalesCurrencyAmount(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px'
                                                    // whiteSpace:"nowrap",
                                                }}
                                            >
                                                Converted Currency Rate :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={updateSalesConvertedRate}
                                                onChange={(e) => setUpdateSalesConvertedRate(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                {/* <span style={{ color: "red" }}>*</span> */}
                                                Top Up Type :
                                            </Typography>
                                            <Select
                                                displayEmpty
                                                value={updateSalesTopUpType}
                                                onChange={(e) => setUpdateSalesTopUpType(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value="">
                                                    Select Top Up Type
                                                </MenuItem>
                                                {topUpTypeList.map((item, index) => (
                                                    <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px'
                                                    // whiteSpace:"nowrap",
                                                }}
                                            >
                                                Top Up Amount :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={updateSalesTopUpAmount}
                                                onChange={(e) => setUpdateSalesTopUpAmount(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px'
                                                    // whiteSpace:"nowrap",
                                                }}
                                            >
                                                Transaction Number :
                                            </Typography>
                                            <input
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={updateTransactionNumber}
                                                onChange={(e) => setUpdateTransactionNumber(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    {salesData?.map((data, index) => (
                                        <>
                                            <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <Typography
                                                        sx={{
                                                            fontSize: '16px',
                                                            whiteSpace: 'nowrap'
                                                        }}
                                                    >
                                                        Third Party :
                                                    </Typography>
                                                    <Select
                                                        displayEmpty
                                                        value={data.thirdPartyID || ''}
                                                        onChange={(e) => handleInputChange(index, 'thirdPartyID', e.target.value)}
                                                    >
                                                        <MenuItem sx={{ width: '100%' }} value="">
                                                            Select Third Party
                                                        </MenuItem>
                                                        {thirdparty.map((item, index) => (
                                                            <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                                {item.name}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </Box>
                                            </Grid>

                                            <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <Typography
                                                        sx={{
                                                            fontSize: '16px'
                                                        }}
                                                    >
                                                        Amount
                                                    </Typography>
                                                    <input
                                                        type="number"
                                                        style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                        value={data.amount}
                                                        onChange={(e) => handleInputChange(index, 'amount', e.target.value)}
                                                        disabled={!data.thirdPartyID}
                                                    />
                                                </Box>
                                                {index === salesData?.length - 1 ? (
                                                    <button
                                                        type="button"
                                                        onClick={handleAddRow}
                                                        style={{ width: '10%', height: '50px', borderRadius: '10px', fontSize: '18px' }}
                                                        disabled={!data.thirdPartyID}
                                                    >
                                                        +
                                                    </button>
                                                ) : (
                                                    <button
                                                        type="button"
                                                        onClick={() => removeRow(index)}
                                                        style={{ width: '10%', height: '50px', borderRadius: '10px', fontSize: '18px' }}
                                                    >
                                                        🗑️
                                                    </button>
                                                )}
                                            </Grid>
                                        </>
                                    ))}
                                </Grid>
                            </Box>
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    mx: 'auto',
                                    width: '150px',
                                    backgroundColor: deepPurple[500],
                                    marginTop: '50px'
                                }}
                                onClick={() => submitUpdateSales()}
                                disabled={updateBtnDisabled}
                            >
                                Update
                            </Button>
                        </Box>
                    )}
                </Modal>
            </>
        );
    };
    //update sales end

    //Change Adjustment start
    // const ChangeUser = ({ salesId }) => {
    //     const [open, setOpen] = useState(false);
    //     const handleOpen = () => setOpen(true);
    //     const handleClose = () => setOpen(false);

    //     const [updateBtnDisabled, setUpdateBtnDisabled] = useState(false);
    //     const [updateSalesRecordLoading, setUpateSalesRecordLoading] = useState(false);

    //     const [oldUsername, setOldUsername] = useState('');
    //     const [newUsername, setNewUsername] = useState('');

    //     const submitUpdateSales = async () => {
    //         setUpdateBtnDisabled(true);
    //         setTimeout(() => {
    //             setUpdateBtnDisabled(false);
    //         }, 3000);
    //         if (parseFloat(salesId) === 0 || oldUsername === '' || newUsername === '') {
    //             warningAlert('Please fill all required fields.');
    //             return;
    //         }
    //         setUpateSalesRecordLoading(true);
    //         try {
    //             const res = await axiosInstance.put(
    //                 '/Sales/ChangeUser',
    //                 {
    //                     salesID: salesId,
    //                     oldUserName: oldUsername,
    //                     newUserName: newUsername
    //                 },
    //                 {
    //                     headers: {
    //                         Authorization: `Bearer ${token}`
    //                     }
    //                 }
    //             );
    //             if (res.status === 200) {
    //                 successAlert('Your username has been updated.');
    //                 fetchAdjustment();
    //             } else {
    //                 errorAlert('Something went wrong.');
    //             }
    //         } catch (error) {
    //             console.log(error);
    //         } finally {
    //             setUpateSalesRecordLoading(false);
    //         }
    //     };

    //     // console.log('User list', usersList);

    //     return (
    //         <>
    //             <Button
    //                 onClick={handleOpen}
    //                 sx={{
    //                     border: 'none',
    //                     backgroundColor: 'transparent',
    //                     width: 'fit-content',
    //                     height: 'fit-content',
    //                     color: deepPurple[500]
    //                 }}
    //             >
    //                 <ChangeCircleIcon />
    //             </Button>

    //             <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
    //                 {updateSalesRecordLoading ? (
    //                     <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
    //                         <CircularProgress />
    //                     </Box>
    //                 ) : (
    //                     <Box sx={style}>
    //                         <Box
    //                             sx={{
    //                                 display: 'flex',
    //                                 alignItems: 'center',
    //                                 justifyContent: 'space-between'
    //                             }}
    //                         >
    //                             <Typography id="modal-modal-title" variant="h3" component="h2">
    //                                 Change Username
    //                             </Typography>
    //                             <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
    //                         </Box>
    //                         <Box
    //                             id="modal-modal-description"
    //                             sx={{
    //                                 height: '300px',
    //                                 overflowY: 'auto'
    //                             }}
    //                         >
    //                             <Grid item container xs={12} sx={{ mt: 2 }}>
    //                                 <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
    //                                     <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
    //                                         <Typography
    //                                             sx={{
    //                                                 fontSize: '16px',
    //                                                 whiteSpace: 'nowrap'
    //                                             }}
    //                                         >
    //                                             <span style={{ color: 'red' }}>*</span>Old Username :
    //                                         </Typography>
    //                                         <FormControl fullWidth>
    //                                             <Select value={oldUsername} onChange={(e) => setOldUsername(e.target.value)}>
    //                                                 <MenuItem sx={{ width: '100%' }} value="">
    //                                                     Old Username
    //                                                 </MenuItem>
    //                                                 {usersList.map((item, index) => (
    //                                                     <MenuItem sx={{ width: '100%' }} value={item.userName} key={index}>
    //                                                         {item.userName}
    //                                                     </MenuItem>
    //                                                 ))}
    //                                             </Select>
    //                                         </FormControl>
    //                                     </Box>
    //                                 </Grid>

    //                                 <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
    //                                     <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
    //                                         <Typography
    //                                             sx={{
    //                                                 fontSize: '16px',
    //                                                 whiteSpace: 'nowrap'
    //                                             }}
    //                                         >
    //                                             <span style={{ color: 'red' }}>*</span>New Username :
    //                                         </Typography>
    //                                         <FormControl fullWidth>
    //                                             <Select value={newUsername} onChange={(e) => setNewUsername(e.target.value)}>
    //                                                 <MenuItem sx={{ width: '100%' }} value="">
    //                                                     New Username
    //                                                 </MenuItem>
    //                                                 {usersList.map((item, index) => (
    //                                                     <MenuItem sx={{ width: '100%' }} value={item.userName} key={index}>
    //                                                         {item.userName}
    //                                                     </MenuItem>
    //                                                 ))}
    //                                             </Select>
    //                                         </FormControl>
    //                                     </Box>
    //                                 </Grid>
    //                             </Grid>
    //                         </Box>
    //                         <Button
    //                             variant="contained"
    //                             sx={{
    //                                 display: 'block',
    //                                 mx: 'auto',
    //                                 width: '150px',
    //                                 backgroundColor: deepPurple[500],
    //                                 marginTop: '50px'
    //                             }}
    //                             onClick={() => submitUpdateSales()}
    //                             disabled={updateBtnDisabled}
    //                         >
    //                             Update
    //                         </Button>
    //                     </Box>
    //                 )}
    //             </Modal>
    //         </>
    //     );
    // };
    //Change Adjustment end

    // With Promise All
    useEffect(() => {
        setLoading(true); // Set loading to true before starting the fetches

        // Define an array of async functions to fetch data
        const fetchFunctions = [fetchIsAllowFilterUserName(), fetchIsAllowedTransaction()];

        // Use Promise.all to wait for all fetches to complete
        Promise.all(fetchFunctions)
            .then(() => {
                setLoading(false); // Set loading to false after all fetches are done
            })
            .catch((error) => {
                // Handle any errors that occurred during fetching
                console.error('Error fetching data:', error);
                setLoading(false); // Set loading to false even if there was an error
            });
    }, []);

    // program selection modal

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 800,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        cursor: 'pointer'
    };

    const ProgramSelectionModal = ({ open, onClose, programs, onSelect }) => {
        const [selectedProgram, setSelectedProgram] = useState(null);

        const handleSelect = () => {
            if (selectedProgram) {
                onSelect(selectedProgram);
            }
        };

        return (
            <Modal open={open} onClose={onClose}>
                <Box sx={{ ...modalStyle }}>
                    <Typography variant="h6" component="h2">
                        Select Lock Program
                    </Typography>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Duration Days</TableCell>
                                <TableCell>Old Percentage</TableCell>
                                <TableCell>New Percentage</TableCell>
                                <TableCell>Old Daily Profit</TableCell>
                                <TableCell>New Daily Profit</TableCell>
                                <TableCell>Old Total Earnings</TableCell>
                                <TableCell>New Total Earnings</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {programs.map((program) => (
                                <TableRow
                                    key={program.lockProgramID}
                                    onClick={() => setSelectedProgram(program)}
                                    selected={selectedProgram?.lockProgramID === program.lockProgramID}
                                >
                                    <TableCell>{program.durationDays}</TableCell>
                                    <TableCell>{program.oldPercentage}</TableCell>
                                    <TableCell>{program.newPercentage}</TableCell>
                                    <TableCell>{program.oldDailyProfit}</TableCell>
                                    <TableCell>{program.newDailyProfit}</TableCell>
                                    <TableCell>{program.oldTotalEarnings}</TableCell>
                                    <TableCell>{program.newTotalEarnings}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
                        <Button variant="contained" color="secondary" onClick={onClose}>
                            Cancel
                        </Button>
                        <Button variant="contained" color="primary" onClick={handleSelect} disabled={!selectedProgram}>
                            Confirm
                        </Button>
                    </Box>
                </Box>
            </Modal>
        );
    };

    //sales table start zzz
    function StickyHeadTable() {
        const [updateLock, setUpdateLock] = useState(false);
        const [fetchSalesLoading, setFetchSalesLoading] = useState(false);
        const [programModalOpen, setProgramModalOpen] = useState(false);
        const [programData, setProgramData] = useState([]);
        const [currentRow, setCurrentRow] = useState(null);

        const handleCheckboxChange = async (row) => {
            setUpdateLock(!updateLock);
            setFetchSalesLoading(true);
            setCurrentRow(row);

            if (!row.isLock) {
                // Fetch program data
                try {
                    const res = await axiosInstance.get(`/LockSales/Preview?customerID=${row.customerID}&salesID=${row.id}`, {
                        // const res = await axiosInstance.get(`/LockSales/Preview?customerID=222&salesID=1664`, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    });
                    if (res.status === 200) {
                        setProgramData(res.data);
                        setProgramModalOpen(true);
                    } else {
                        errorAlert('Failed to fetch program data.');
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    setFetchSalesLoading(false);
                }
            } else {
                updateLockStatus(row, row.isLock, null);
            }
        };

        const updateLockStatus = async (row, currentLockStatus, lockProgramID) => {
            try {
                const res = await axiosInstance.put(
                    `/Sales/LockUnlock`,
                    { salesID: row.id, currentLockStatus, lockProgramID },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200 && res.data === true) {
                    fetchSales();
                    successAlert('Sale Lock updated successfully.');
                } else {
                    errorAlert('Something went wrong.');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setFetchSalesLoading(false);
            }
        };

        const handleProgramSelect = (program) => {
            setProgramModalOpen(false);
            updateLockStatus(currentRow, currentRow.isLock, program.lockProgramID);
        };

        return (
            <Box sx={{ width: '100%', minHeight: '200px', paddingBottom: '50px' }}>
                {fetchSalesLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                        <TableContainer sx={{ maxHeight: 440 }}>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        {columns.map((column) => (
                                            <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                                {column.label}
                                            </TableCell>
                                        ))}
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {sales.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                        return (
                                            <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                                {columns.map((column) => {
                                                    let value = row[column.id];
                                                    if (value === true) value = <>&#9989;</>;
                                                    else if (value === false) value = <>&#10060;</>;

                                                    if (column.type && column.type === 'date') {
                                                        if (value) {
                                                            const timeString12hr = new Date(
                                                                '1970-01-01T' + value.split('T')[1] + 'Z'
                                                            ).toLocaleTimeString('en-US', {
                                                                timeZone: 'UTC',
                                                                hour12: true,
                                                                hour: 'numeric',
                                                                minute: 'numeric',
                                                                second: 'numeric'
                                                            });
                                                            value = `${value.split('T')[0]} ${timeString12hr}`;
                                                        }
                                                    }

                                                    if (column.id2) {
                                                        value = `${row[column.id] || '-'} / ${row[column.id2] || '-'}`;
                                                    }
                                                    return (
                                                        <TableCell key={column.id} align={column.align}>
                                                            {column.format && typeof value === 'number' ? column.format(value) : value}
                                                        </TableCell>
                                                    );
                                                })}

                                                {isUserAllowEdit && (
                                                    <TableCell>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '10px'
                                                            }}
                                                        >
                                                            <ImagesDialog imageUrl={row.imageUrl} />
                                                        </Box>
                                                    </TableCell>
                                                )}

                                                {isUserAllowEdit && (
                                                    <TableCell>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '10px'
                                                            }}
                                                        >
                                                            <ViewDetailsModal id={row.id} />
                                                            <UpdateSalesRecord sale={row} />
                                                            <Tooltip title="Sale Lock/Unlock">
                                                                <Checkbox
                                                                    checked={row.isLock}
                                                                    size="small"
                                                                    onChange={() => handleCheckboxChange(row)}
                                                                />
                                                            </Tooltip>
                                                        </Box>
                                                    </TableCell>
                                                )}
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 100]}
                            component="div"
                            count={sales.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Paper>
                )}
                <ProgramSelectionModal
                    open={programModalOpen}
                    onClose={() => setProgramModalOpen(false)}
                    programs={programData}
                    onSelect={handleProgramSelect}
                />
            </Box>
        );
    }

    //sales table end

    //ThirdPartyTransactionLimit table start
    function StickyThirdPartyTransactionLimitHeadTable() {
        const [page, setPage] = useState(0);
        const [rowsPerPage, setRowsPerPage] = useState(100);

        const handleChangePage = (event, newPage) => {
            setPage(newPage);
        };

        const handleChangeRowsPerPage = (event) => {
            setRowsPerPage(+event.target.value);
            setPage(0);
        };

        return (
            <Box sx={{ width: '100%', minHeight: '200px' }}>
                {fetchSalesLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Paper sx={{ width: '100%', overflow: 'hidden', margin: '20px 0px' }}>
                        <TableContainer sx={{ maxHeight: 440 }}>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        {transactionLimitColumns.map((column) => (
                                            <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                                {column.label}
                                            </TableCell>
                                        ))}
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {thirdPartyTransactionLimitList
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((row) => {
                                            return (
                                                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                                    {transactionLimitColumns.map((column) => {
                                                        let value = row[column.id];
                                                        if (column.type && column.type === 'date') {
                                                            if (value) {
                                                                const timeString12hr = new Date(
                                                                    '1970-01-01T' + value.split('T')[1] + 'Z'
                                                                ).toLocaleTimeString('en-US', {
                                                                    timeZone: 'UTC',
                                                                    hour12: true,
                                                                    hour: 'numeric',
                                                                    minute: 'numeric',
                                                                    second: 'numeric'
                                                                });
                                                                value = `${value.split('T')[0]} ${timeString12hr}`;
                                                            }
                                                        }
                                                        return (
                                                            <TableCell key={column.id} align={column.align}>
                                                                {column.format && typeof value === 'number' ? column.format(value) : value}
                                                            </TableCell>
                                                        );
                                                    })}
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 100]}
                            component="div"
                            count={thirdPartyTransactionLimitList.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Paper>
                )}
            </Box>
        );
    }
    //ThirdPartyTransactionLimit table end

    return (
        <Grid container item xs={12}>
            {/* <Typography id="modal-modal-title" variant="h3" component="h2" margin="10px 0px">
                Third Party Transaction Limit List
            </Typography> */}
            {/* <StickyThirdPartyTransactionLimitHeadTable /> */}

            {isUserAllowEdit && <InsertSalesRecord />}

            <Grid item container xs={12} spacing={gridSpacing} sx={{ marginBottom: '10px', overflowY: 'auto' }}>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span style={{ color: 'red' }}>*</span>From :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterSalesFrom}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilerSalesFrom(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span style={{ color: 'red' }}>*</span>To :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterSalesTo}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilerSalesTo(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>

                {/* Client Name */}
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Login UserName :
                        </Typography>
                        <Autocomplete
                            freeSolo
                            value={filterSalesClientLoginUserName}
                            onChange={(event, newValue) => {
                                setFilterSalesClientLoginUserName(newValue);
                            }}
                            inputValue={filterSalesClientLoginUserName}
                            onInputChange={(event, newInputValue) => {
                                setFilterSalesClientLoginUserName(newInputValue);
                            }}
                            id="controllable-states-demo"
                            options={customerLoginUserNameOptions}
                            sx={{ width: 170 }}
                            renderInput={(params) => <TextField {...params} />}
                            disableClearable
                        />
                    </Box>
                </Grid>

                {/* User Name */}
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap',
                                color: isAllowFilterUserName ? '' : 'grey'
                            }}
                        >
                            Created By :
                        </Typography>

                        <Select
                            disabled={!isAllowFilterUserName}
                            displayEmpty
                            value={filterSalesUserName}
                            onChange={(e) => setFilterSalesUserName(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value="">
                                Select Created By
                            </MenuItem>
                            {usersList.map((item, index) => (
                                <MenuItem sx={{ width: '100%' }} value={item.userID} key={index}>
                                    {item.userName}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Package :
                        </Typography>
                        <Select
                            displayEmpty
                            value={filterSalesPackage}
                            onChange={(e) => setFilterSalesPackage(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value="">
                                Select Package
                            </MenuItem>
                            {packages.map((item, index) => (
                                <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Status :
                        </Typography>
                        <Select
                            displayEmpty
                            value={filterSalesStatus}
                            onChange={(e) => setFilterSalesStatus(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value="">
                                Select Status
                            </MenuItem>
                            {saleStatus.map((item, index) => (
                                <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </Grid>
                {/* <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Third Party :
                        </Typography>
                        <Select
                            displayEmpty
                            value={filterSalesThirdParty}
                            onChange={(e) => setFilterSalesThirdParty(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value="">
                                Select Third Party
                            </MenuItem>
                            {thirdparty.map((item, index) => (
                                <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </Grid> */}

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            ROI :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterSalesRoi}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilerSalesRoi(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Is Lock :
                        </Typography>
                        <Select value={filterIsLock} onChange={(e) => setFilterIsLock(e.target.value)}>
                            <MenuItem value="all">All</MenuItem>
                            <MenuItem value="lock">Lock</MenuItem>
                            <MenuItem value="notlock">Not Lock</MenuItem>
                        </Select>
                    </Box>
                </Grid>

                {/* <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Customer ID :
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            value={filterSalesCustomerID}
                            onChange={(e) => setFilterSalesCustomerID(e.target.value)}
                        />
                    </Box>
                </Grid> */}

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Transaction Number :
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            value={transactionNumber}
                            onChange={(e) => setTransactionNumber(e.target.value)}
                        />
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Top Up Type :
                        </Typography>
                        <Select
                            displayEmpty
                            value={filterSalesTopUpTypeID}
                            onChange={(e) => setFilterSalesTopUpTypeID(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value="" selected>
                                Select Top Up Type
                            </MenuItem>
                            {topUpTypeList.map((item, index) => (
                                <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Approved Date From :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterSalesApprovedDateFrom}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilterSalesApprovedDateFrom(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Approved Date To :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterSalesApprovedDateTo}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilterSalesApprovedDateTo(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Package End Date :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterSalesPackageEndDate}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilterSalesPackageEndDate(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Package Type :
                        </Typography>
                        <Select
                            displayEmpty
                            value={filterSalesPackageTypeID}
                            onChange={(e) => setFilterSalesPackageTypeID(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value="" selected>
                                Select Package Type
                            </MenuItem>
                            {packageTypeList.map((item, index) => (
                                <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Is Recommend :
                        </Typography>
                        <Select
                            displayEmpty
                            value={filterSalesIsRecommend}
                            onChange={(e) => setFilterSalesIsRecommend(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value="">
                                All
                            </MenuItem>
                            <MenuItem sx={{ width: '100%' }} value="true">
                                True
                            </MenuItem>
                            <MenuItem sx={{ width: '100%' }} value="false">
                                False
                            </MenuItem>
                        </Select>
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Is Multiple Third Party :
                        </Typography>
                        <Select
                            displayEmpty
                            value={filterSalesIsMultipleThirdParty}
                            onChange={(e) => setFilterSalesIsMultipleThirdParty(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value="">
                                All
                            </MenuItem>
                            <MenuItem sx={{ width: '100%' }} value="true">
                                True
                            </MenuItem>
                            <MenuItem sx={{ width: '100%' }} value="false">
                                False
                            </MenuItem>
                        </Select>
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Customer Type :
                        </Typography>
                        <Select
                            displayEmpty
                            value={filterSalesCustomerTypeID}
                            onChange={(e) => setFilterSalesCustomerTypeID(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value="">
                                All
                            </MenuItem>
                            <MenuItem sx={{ width: '100%' }} value="1">
                                Promotion Package
                            </MenuItem>
                            <MenuItem sx={{ width: '100%' }} value="2">
                                Referral Customer
                            </MenuItem>
                            <MenuItem sx={{ width: '100%' }} value="3">
                                New Customer
                            </MenuItem>
                            <MenuItem sx={{ width: '100%' }} value="4">
                                Repeat Customer
                            </MenuItem>
                            <MenuItem sx={{ width: '100%' }} value="5">
                                Existing Customer
                            </MenuItem>
                        </Select>
                    </Box>
                </Grid>

                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'end',
                        alignItems: 'center',
                        gap: '15px',
                        width: '50%',
                        marginLeft: 'auto'
                    }}
                >
                    <Button
                        variant="contained"
                        sx={{
                            display: 'block',
                            mx: 'auto',
                            width: '150px',
                            backgroundColor: deepPurple[500],
                            marginTop: '20px',
                            marginBottom: '20px'
                        }}
                        onClick={() => fetchSales()}
                        disabled={filterBtnDisabled}
                    >
                        Filter
                    </Button>

                    <Button
                        variant="contained"
                        sx={{
                            display: 'block',
                            mx: 'auto',
                            width: '150px',
                            backgroundColor: deepPurple[500],
                            marginTop: '20px',
                            marginBottom: '20px'
                        }}
                        onClick={() => exportDataAsXlsx()}
                        disabled={filterBtnDisabled}
                    >
                        Export Data
                    </Button>
                </Box>
            </Grid>

            <Typography style={{ margin: '30px 0px' }} id="modal-modal-title" variant="h3" component="h2">
                Sales Record List
            </Typography>
            <StickyHeadTable />
        </Grid>
    );
};

export default SalesRecord;
